<template>
  <div class="sel-modal clearfix">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li>
            <vxe-radio name="xtabs" label="tab1">历史收款人</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="search-box" style="display: flex;align-items: center">
        <vxe-input style="height: 34px !important;border: 1px solid #dcdee2;margin-right: 10px;" v-model="recUserName"
                   type="search" placeholder="账户名称" @keyup.enter.native="search" @search-click="search"></vxe-input>
        <vxe-input style="height: 34px !important;border: 1px solid #dcdee2;" v-model="recBankAccount" type="search"
                   placeholder="银行账号" @keyup.enter.native="search" @search-click="search"></vxe-input>
        <Button type="primary" style="margin-left: 10px;" @click="search">搜索</Button>
      </div>
    </div>
    <div v-show="selectTab === 'tab1'">
      <vxe-table
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          border="none"
          ref="xTable"
          class="table-style"
          max-height="430"
          align="center"
          :auto-resize="true"
          :data="tableData"
          :loading="loading"
          @current-change="currentChangeEvent"
      >
        <vxe-table-column field="id" title="序号"></vxe-table-column>
        <vxe-table-column field="recUserName" title="收款人名称" width="150"></vxe-table-column>
        <vxe-table-column field="recPhone" title="收款人手机号"></vxe-table-column>
        <vxe-table-column field="recBankAccount" title="收款人银行账号"></vxe-table-column>
        <vxe-table-column field="recBankName" title="收款人开户银行"></vxe-table-column>
        <vxe-table-column title="操作">
          <template slot-scope="{ row }">
            <span style="color: red; cursor: pointer;margin-right: 10px" @click.stop="commitDelete(row.id)">删除</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
import $api from '@/apiProvider'
import getAuthOrization from "@/mixin/getAuthOrization";
import {hideLoading, showLoading} from "@/utils/util";

export default {
  name: "AccHistory",
  mixins: [getAuthOrization],
  data() {
    return {
      selectTab: "tab1",
      recUserName: null,
      recBankAccount: null,
      tableData: [],
      loading: false,
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
    };
  },
  created() {

  },
  methods: {
    commitDelete(id) {
      this.$XModal.confirm("您确定要删除吗？").then(type => {
        if (type === "confirm") {
          this.delClientPayApplyHistory(id);
        }
      });
    },
    async delClientPayApplyHistory(id) {
      showLoading();
      let res = await $api.twoPayments.post("delClientPayApplyHistory", {
        id: id
      });
      hideLoading();
      if (res.status === 1) {
        this.$XModal.message({message: '删除成功！'});
        this.queryClientPayApplyHistoryList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    changePage(e) {
      this.page.currentPage = e.currentPage;
      this.page.pageSize = e.pageSize;
      this.queryClientPayApplyHistoryList();
    },
    currentChangeEvent({row}) {
      this.$emit("choose", row);
    },
    search() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.queryClientPayApplyHistoryList();
    },
    init() {
      this.page = {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      };
      this.recUserName = null;
      this.recBankAccount = null;
      this.queryClientPayApplyHistoryList();
    },
    async queryClientPayApplyHistoryList() {
      this.loading = true;
      let res = await $api.twoPayments.request('queryClientPayApplyHistoryList', {
        recUserName: this.recUserName,
        page: this.page.currentPage,
        rows: this.page.pageSize,
        recBankAccount: this.recBankAccount,
      });
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        this.tableData = res.data.list;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.selectTab = "tab1";
      this.recUserName = null;
      this.recBankAccount = null;
      this.page = {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      };
      this.$refs.xTable.clearCurrentRow();
    }
  },
};
</script>

<style>

</style>